export const SET_FILTER = "SET_FILTER";

export const SET_ME = "SET_ME";

export const ORGS_REQUEST = "ORGS_REQUEST";
export const ORGS_SUCCESS = "ORGS_SUCCESS";
export const ORGS_FAILURE = "ORGS_FAILURE";

export const OPTIONS_REQUEST = "OPTIONS_REQUEST";
export const OPTIONS_SUCCESS = "OPTIONS_SUCCESS";
export const OPTIONS_FAILURE = "OPTIONS_FAILURE";

export const SUMMARY_REQUEST = "SUMMARY_REQUEST";
export const SUMMARY_SUCCESS = "SUMMARY_SUCCESS";
export const SUMMARY_FAILURE = "SUMMARY_FAILURE";
